<template>
  <div id="teacher_prize">
    <div class="over_ta">
      <div class="tea_li" style="margin-bottom: 40px;">
        <div class="tea_title"><i class="fa fa-chevron-circle-down mr5" aria-hidden="true"></i>{{showPage.award}}</div>
          <div v-html="showHonor()"></div>
        <div class="tea_title"><i class="fa fa-chevron-circle-down mr5" aria-hidden="true"></i>{{showPage.experience}}</div>
          <div v-html="showHistory()"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import { API, Message,ShowPage } from '@/assets/project_setting/config';
import { GetErrorHandler, ShowMessage } from '@/assets/library/axiosErrorHandler';

export default {
  name: 'teacher_prize',
  props: ['teacher'],
  data() {
    return {
      info: {},
      showPage: ShowPage(sessionStorage.getItem('locale')),
    };
  },
  created() {
    this.init();
  },
  methods: {
    

    showHonor() {
      let show = {CH: (this.teacher.honorCh), EN: (this.teacher.honorEn)};
      return show[sessionStorage.locale];
    },
    showHistory() {
      let show = {CH: (this.teacher.historyCh), EN: (this.teacher.historyEn)};
      return show[sessionStorage.locale];
    },
  },
}

</script>
<style lang="scss">


</style>



// WEBPACK FOOTER //
// TeacherPrize.vue?c64b6e7e